module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    class: {
      'is-single': _vm.isSingle
    }
  }, [_c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "height": "0",
      "width": "0"
    }
  }, [_c('symbol', {
    attrs: {
      "id": "icon-about",
      "viewBox": "0 0 350 350"
    }
  }, [_c('path', {
    attrs: {
      "d": "M175 171.173c38.914 0 70.463-38.318 70.463-85.586C245.463 38.318 235.105 0 175 0s-70.465 38.318-70.465 85.587c0 47.268 31.549 85.586 70.465 85.586zM41.909 301.853c-.012-2.882-.024-.812 0 0zM308.085 304.104c.038-.789.013-5.474 0 0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M307.935 298.397c-1.305-82.342-12.059-105.805-94.352-120.657 0 0-11.584 14.761-38.584 14.761s-38.586-14.761-38.586-14.761C55.018 192.43 43.61 215.545 42.11 295.722c-.123 6.547-.18 6.891-.202 6.131.005 1.424.011 4.058.011 8.651 0 0 19.592 39.496 133.08 39.496 113.486 0 133.08-39.496 133.08-39.496 0-2.951.002-5.003.005-6.399-.022.47-.066-.441-.149-5.708z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "icon-gh",
      "viewBox": "0 0 438.549 438.549"
    }
  }, [_c('path', {
    attrs: {
      "d": "M409.132 114.573c-19.608-33.596-46.205-60.194-79.798-79.8-33.598-19.607-70.277-29.408-110.063-29.408-39.781 0-76.472 9.804-110.063 29.408-33.596 19.605-60.192 46.204-79.8 79.8C9.803 148.168 0 184.854 0 224.63c0 47.78 13.94 90.745 41.827 128.906 27.884 38.164 63.906 64.572 108.063 79.227 5.14.954 8.945.283 11.419-1.996 2.475-2.282 3.711-5.14 3.711-8.562 0-.571-.049-5.708-.144-15.417-.098-9.709-.144-18.179-.144-25.406l-6.567 1.136c-4.187.767-9.469 1.092-15.846 1-6.374-.089-12.991-.757-19.842-1.999-6.854-1.231-13.229-4.086-19.13-8.559-5.898-4.473-10.085-10.328-12.56-17.556l-2.855-6.57c-1.903-4.374-4.899-9.233-8.992-14.559-4.093-5.331-8.232-8.945-12.419-10.848l-1.999-1.431c-1.332-.951-2.568-2.098-3.711-3.429-1.142-1.331-1.997-2.663-2.568-3.997-.572-1.335-.098-2.43 1.427-3.289 1.525-.859 4.281-1.276 8.28-1.276l5.708.853c3.807.763 8.516 3.042 14.133 6.851 5.614 3.806 10.229 8.754 13.846 14.842 4.38 7.806 9.657 13.754 15.846 17.847 6.184 4.093 12.419 6.136 18.699 6.136 6.28 0 11.704-.476 16.274-1.423 4.565-.952 8.848-2.383 12.847-4.285 1.713-12.758 6.377-22.559 13.988-29.41-10.848-1.14-20.601-2.857-29.264-5.14-8.658-2.286-17.605-5.996-26.835-11.14-9.235-5.137-16.896-11.516-22.985-19.126-6.09-7.614-11.088-17.61-14.987-29.979-3.901-12.374-5.852-26.648-5.852-42.826 0-23.035 7.52-42.637 22.557-58.817-7.044-17.318-6.379-36.732 1.997-58.24 5.52-1.715 13.706-.428 24.554 3.853 10.85 4.283 18.794 7.952 23.84 10.994 5.046 3.041 9.089 5.618 12.135 7.708 17.705-4.947 35.976-7.421 54.818-7.421s37.117 2.474 54.823 7.421l10.849-6.849c7.419-4.57 16.18-8.758 26.262-12.565 10.088-3.805 17.802-4.853 23.134-3.138 8.562 21.509 9.325 40.922 2.279 58.24 15.036 16.18 22.559 35.787 22.559 58.817 0 16.178-1.958 30.497-5.853 42.966-3.9 12.471-8.941 22.457-15.125 29.979-6.191 7.521-13.901 13.85-23.131 18.986-9.232 5.14-18.182 8.85-26.84 11.136-8.662 2.286-18.415 4.004-29.263 5.146 9.894 8.562 14.842 22.077 14.842 40.539v60.237c0 3.422 1.19 6.279 3.572 8.562 2.379 2.279 6.136 2.95 11.276 1.995 44.163-14.653 80.185-41.062 108.068-79.226 27.88-38.161 41.825-81.126 41.825-128.906-.01-39.771-9.818-76.454-29.414-110.049z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "icon-fb",
      "viewBox": "0 0 455.73 455.73"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,0v455.73h242.704V279.691h-59.33v-71.864h59.33v-60.353c0-43.893,35.582-79.475,79.475-79.475h62.025v64.622h-44.382c-13.947,0-25.254,11.307-25.254,25.254v49.953h68.521l-9.47,71.864h-59.051V455.73H455.73V0H0z"
    }
  })]), _vm._v(" "), _c('symbol', {
    attrs: {
      "id": "icon-mail",
      "viewBox": "0 0 511.626 511.626"
    }
  }, [_c('path', {
    attrs: {
      "d": "M49.106,178.729c6.472,4.567,25.981,18.131,58.528,40.685c32.548,22.554,57.482,39.92,74.803,52.099c1.903,1.335,5.946,4.237,12.131,8.71c6.186,4.476,11.326,8.093,15.416,10.852c4.093,2.758,9.041,5.852,14.849,9.277c5.806,3.422,11.279,5.996,16.418,7.7c5.14,1.718,9.898,2.569,14.275,2.569h0.287h0.288c4.377,0,9.137-0.852,14.277-2.569c5.137-1.704,10.615-4.281,16.416-7.7c5.804-3.429,10.752-6.52,14.845-9.277c4.093-2.759,9.229-6.376,15.417-10.852c6.184-4.477,10.232-7.375,12.135-8.71c17.508-12.179,62.01-43.11,133.615-92.79c13.894-9.703,25.502-21.411,34.827-35.116c9.332-13.699,13.993-28.07,13.993-43.105c0-12.564-4.523-23.319-13.565-32.264c-9.041-8.947-19.749-13.418-32.117-13.418H45.679c-14.655,0-25.933,4.948-33.832,14.844C3.949,79.562,0,91.934,0,106.779c0,11.991,5.236,24.985,15.703,38.974C26.169,159.743,37.307,170.736,49.106,178.729z"
    }
  }), _c('path', {
    attrs: {
      "d": "M483.072,209.275c-62.424,42.251-109.824,75.087-142.177,98.501c-10.849,7.991-19.65,14.229-26.409,18.699c-6.759,4.473-15.748,9.041-26.98,13.702c-11.228,4.668-21.692,6.995-31.401,6.995h-0.291h-0.287c-9.707,0-20.177-2.327-31.405-6.995c-11.228-4.661-20.223-9.229-26.98-13.702c-6.755-4.47-15.559-10.708-26.407-18.699c-25.697-18.842-72.995-51.68-141.896-98.501C17.987,202.047,8.375,193.762,0,184.437v226.685c0,12.57,4.471,23.319,13.418,32.265c8.945,8.949,19.701,13.422,32.264,13.422h420.266c12.56,0,23.315-4.473,32.261-13.422c8.949-8.949,13.418-19.694,13.418-32.265V184.437C503.441,193.569,493.927,201.854,483.072,209.275z"
    }
  })])]), _vm._v(" "), _c('div', {
    class: ['fr-tp', {
      'single-nav': _vm.isSingle
    }],
    style: ({
      backgroundColor: _vm.frameColor
    }),
    attrs: {
      "id": "fr-tp"
    }
  }, [(_vm.isSingle) ? [_c('div', {
    staticClass: "single-prev-next"
  }, [_c('a', {
    class: ['single-prev', {
      'is-disabled': !_vm.prevLink
    }],
    on: {
      "click": function($event) {
        _vm.navigate(_vm.prevLink)
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 407.436 407.436"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "315.869,21.178 294.621,0 91.566,203.718 294.621,407.436 315.869,386.258 133.924,203.718"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Previous")])]), _vm._v(" "), _c('a', {
    class: ['single-next', {
      'is-disabled': !_vm.nextLink
    }],
    on: {
      "click": function($event) {
        _vm.navigate(_vm.nextLink)
      }
    }
  }, [_c('span', [_vm._v("Next")]), _vm._v(" "), _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 407.436 407.436"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 "
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "close",
    on: {
      "click": _vm.closeSingle
    }
  }, [_c('span', [_vm._v("Close")]), _vm._v(" "), _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 224.512 224.512"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "224.507,6.997 217.521,0 112.256,105.258 6.998,0 0.005,6.997 105.263,112.254 0.005,217.512 6.998,224.512 112.256,119.24 217.521,224.512 224.507,217.512 119.249,112.254"
    }
  })])])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "fr-rt",
    style: ({
      backgroundColor: _vm.frameColor
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "fr-lt",
    style: ({
      backgroundColor: _vm.frameColor
    })
  }), _vm._v(" "), _c('div', {
    class: ['fr-bt', {
      'is-disabled': _vm.jumpedDown
    }],
    style: ({
      backgroundColor: _vm.frameColor
    }),
    attrs: {
      "id": "fr-bt"
    }
  }, [_c('button', {
    staticClass: "frame-btn",
    on: {
      "click": function($event) {
        _vm.jumpTo('.portfolio')
      }
    }
  }, [_vm._v("\n            View More\n        ")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e()]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-617ab0be"}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/App.vue
// module id = 129
// module chunks = 0